import { atom } from 'recoil';

export const showHeaderFilialAtom = atom({ key: 'showHeaderFilialAtom', default: false });